import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import Breadcrumbs from './breadcrumbs';


class Component extends BaseComponent {

    render({ result }) {
        let label_title = result.og_title && result.og_title.snippet.replace(/<[^>]*>?/gm, '');
        let meta_description = result.meta_description && result.meta_description.snippet;
        if (meta_description && ! meta_description.endsWith('.') &&
            meta_description.replace(/<[^>]*>?/gm, '') != result.meta_description.raw) {
            meta_description = meta_description + ' …';
        }
        /* eslint-disable max-len */
        return (<li className='sui-result has-padding-0'>
            <row className='sui-result__body'>
                <column
                    className='sui-result__image is-3 is-12-mobile has-padding-0-left-mobile has-padding-0-bottom-mobile'
                >
                    <a
                        data-label={'Image:' + label_title}
                        href={result.url.raw}
                        onClick={this.trackClick}
                        target='_blank'>
                        <img
                            alt='thumb'
                            className='is-visible-mobile has-padding-5-bottom has-padding-0-top'
                            src={this.getImage(result.og_image, true)}
                        />
                        <img
                            alt='thumb'
                            className='is-hidden-mobile has-padding-10-bottom has-padding-10-top'
                            src={this.getImage(result.og_image, false)}
                        />
                    </a>
                </column>
                <column className='sui-result__details is-9 is-12-mobile has-padding-0-mobile'>
                    <Breadcrumbs
                        breadcrumb={result.breadcrumb}
                        links={result.links}
                        url_path_dir1={result.url_path_dir1 && result.url_path_dir1.raw}
                        url_path_dir2={result.url_path_dir2 && result.url_path_dir2.raw}
                        trackClick={this.trackClick}
                    />
                    <li className='has-padding-15-left-mobile has-padding-15-right-mobile'>
                        <a
                            className='no_underline_hover'
                            data-label={'Title:' + label_title}
                            href={result.url.raw}
                            onClick={this.trackClick}
                            target='_blank'
                        >
                            <h3
                                className='sui-result__title is-h1 has-margin-0-top has-margin-15-bottom'
                                // Snippeted results contain search term highlights with html and are
                                // 100% safe and santitized, so we dangerously set them here
                                dangerouslySetInnerHTML={{ __html: result.og_title && result.og_title.snippet}}
                            />
                            <p
                                className='sui-result__value has-margin-20-bottom'
                                dangerouslySetInnerHTML={{
                                    __html: meta_description,
                                }}
                            />
                        </a>
                    </li>
                </column>
            </row>
        </li>);
        /* eslint-enable max-len */
    }

    getImage = (og_image, is_mobile) => {
        let image = 'https://gfx.tarot.com/images/feeds/625x625/tarot-hand-625x625.jpg';
        if (og_image) {
            image = og_image.raw;
        }
        if (is_mobile) {
            image = image.replace(/625x625/g, '380x235');
        }
        return image;
    };

    trackClick = (e) => {
        const category = 'Search';
        const action = this.props.user.logged_in ? 'LI Click' : 'LO Click';
        const label = e.currentTarget.dataset.label;

        this.props.trackEvent([category, action, label]);
        this.props.trackPromo([category, label]);
    };

}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
